import { render, staticRenderFns } from "./aboutWeb.vue?vue&type=template&id=0e2cfc39&"
import script from "./aboutWeb.vue?vue&type=script&lang=js&"
export * from "./aboutWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports